import { useEffect, useState } from "react";
import { useProfileContext } from "api/settings/profile/ProfileProvider";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import Button from "core/buttons/button/Button";

export default function AdminProfile({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    profileByIdGetter,
    profileCreate,
    profileDeleteById,
    profileList,
    profileListGetter,
    profilePerId,
    profileUpdateById,
  } = useProfileContext();

  const profileForm = [
    { col: "id", mandatory: false, editable: false, isMissingValue: null },
    { col: "fr_m", mandatory: true, editable: true, isMissingValue: null },
    { col: "fr_f", mandatory: true, editable: true, isMissingValue: null },
    { col: "en_m", mandatory: true, editable: true, isMissingValue: null },
    { col: "en_f", mandatory: true, editable: true, isMissingValue: null },
  ];

  const allowedKeys = profileForm?.map((e) => e.col);

  const filteredProfileList = profileList?.map((e) =>
    Object.fromEntries(
      Object.entries(e).filter(([key]) => allowedKeys.includes(key))
    )
  );

  const filteredProfilePerId = Object.fromEntries(
    Object.entries(profilePerId).filter(([key]) => allowedKeys.includes(key))
  );

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    profileListGetter();
  }, [profileListGetter]);

  useEffect(() => {
    if (id) {
      profileByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (profileId) =>
    setDeleteData(filteredProfileList.find((e) => e.id === profileId));

  const validateDelete = async (profileId) => {
    try {
      await profileDeleteById(profileId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      profileCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      profileUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.PROFILE}
        entityPerId={filteredProfilePerId}
        list={filteredProfileList}
        inputs={profileForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />

      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.PROFILE}
        />
      </div>
    </div>
  );
}
